// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./asset-folder-closed.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td {
  padding: 5px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.asset-list-item-name {
  padding: 8px;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-list-item-name:hover {
  text-decoration: none;
}

.asset-list-item-clickable {
  cursor: pointer;
}

.asset-list-item-date {
  width: 125px;
  max-width: 125px;
}

.asset-list-item-fileSize {
  width: 125px;
  max-width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.asset-list-item-icon {
  cursor: pointer;
  padding-left: 8px;
  padding-right: 8px;
  position: initial;
}

.al-folder-thumbnail-icon {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
  cursor: pointer;
  height: 30px;
  -o-object-fit: "contain";
     object-fit: "contain";
  padding-left: 5px;
  padding-right: 5px;
  width: 30px;
}

.asset-list-item.selected {
  font-weight: bold;
}
.asset-list-item.selected > td {
  background-color: #e1effa !important;
}

.asset-list-item.deselected {
  opacity: 0.6;
}

.asset-list-item.disabled {
  opacity: 0.6;
}
.asset-list-item.disabled .asset-list-item-clickable {
  cursor: default;
}
.asset-list-item.disabled .asset-list-item-name:hover {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./../app-web/public/app/assetLibrary/components/AssetTableView/AssetTableViewItem.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AACJ;;AAEA;EACI,YAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,uFAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;KAAA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;AACI;EACI,oCAAA;AACR;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;AAEI;EACI,eAAA;AAAR;AAGI;EACI,qBAAA;AADR","sourcesContent":["td {\n    padding: 5px;\n    user-select: none;\n}\n\n.asset-list-item-name {\n    padding: 8px;\n    display: inline-block;\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.asset-list-item-name:hover {\n    text-decoration: none;\n}\n\n.asset-list-item-clickable {\n    cursor: pointer;\n}\n\n.asset-list-item-date {\n    width: 125px;\n    max-width: 125px;\n}\n\n.asset-list-item-fileSize {\n    width: 125px;\n    max-width: 125px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.asset-list-item-icon {\n    cursor: pointer;\n    padding-left: 8px;\n    padding-right: 8px;\n    position: initial;\n}\n\n.al-folder-thumbnail-icon {\n    background: transparent url('./asset-folder-closed.svg') center center no-repeat;\n    cursor: pointer;\n    height: 30px;\n    object-fit: 'contain';\n    padding-left: 5px;\n    padding-right: 5px;\n    width: 30px;\n}\n\n.asset-list-item.selected {\n    font-weight: bold;\n\n    & > td {\n        background-color: #e1effa !important;\n    }\n}\n\n.asset-list-item.deselected {\n    opacity: 0.6;\n}\n\n.asset-list-item.disabled {\n    opacity: 0.6;\n\n    .asset-list-item-clickable {\n        cursor: default;\n    }\n\n    .asset-list-item-name:hover {\n        text-decoration: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
